export default {
  client_client: [],
  type_services: []
};
